$(document).ready(function () {

  // ADA issues fixed by Arpit
  $(".boost-pfs-in-collection-search-button").attr('aria-label','search product');
   $('.boost-pfs-filter-option-item').each(function() {
        // Check if the element has the 'is_selected' class
        if ($(this).hasClass('selected')) {
            // Set the aria-checked attribute of the child button to true
            $(this).find('button').attr('aria-checked', 'true');
            $(this).find('.boost-pfs-check-box').attr('aria-checked', 'true');
            $(this).find('.boost-pfs-check-box').removeAttr('tabindex');
            $(this).find('.boost-pfs-check-box').attr('aria-label', $(this).find('.boost-pfs-check-box').attr('aria-labelledby'));
          
        } else {
            // Set the aria-checked attribute of the child button to false
            $(this).find('button').attr('aria-checked', 'false');
            $(this).find('.boost-pfs-check-box').attr('aria-checked', 'false');
            $(this).find('.boost-pfs-check-box').removeAttr('tabindex');
            $(this).find('.boost-pfs-check-box').attr('aria-label', $(this).find('.boost-pfs-check-box').attr('aria-labelledby'));
          
        }
    });
  // ADA issues fixes end

  // Function to disable and change color of cart icon
  function disableCartIcon() {
    // Disable the cart icon, change the color to red, and set the cursor to 'not-allowed'
    $(".site-header-cart--button").prop("disabled", true).css({
      cursor: "not-allowed",
    });

    // Enable the cart icon, reset color, and set the cursor to 'auto' after 3 seconds
    setTimeout(function () {
      $(".site-header-cart--button").prop("disabled", false).css({
        cursor: "pointer",
      });
    }, 1500);
  }

  // Attach the function to the "Add to Cart" button click event
  $(".product-form--atc-button, .productitem--action-trigger").on(
    "click",
    function () {
      disableCartIcon();
    }
  );
});

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let cookiesArray = decodedCookie.split(";");
  for (let i = 0; i < cookiesArray.length; i++) {
    let cookie = cookiesArray[i];
    while (cookie.charAt(0) == " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
}

(function () {
  let path = window.location.pathname;
  let pathParts = path.split("/");

  // Ensure there is a second part in the path
  if (pathParts.length > 1) {
    let countryCode = pathParts[1];

    // If the country code contains a dash, split it and take the last part; otherwise, take the entire code
    let selectedRegion = countryCode.includes("-")
      ? countryCode.split("-").pop().toUpperCase()
      : countryCode.toUpperCase();

    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json;",
        },
        body: JSON.stringify({
          attributes: {
            selectedRegion: selectedRegion,
          },
        }),
      });
    } catch (error) {
      console.log(error);
    }
  }
})();

 window.onload = function() {
     setTimeout(function(){
      if(document.querySelector('#app-embed')) 
      {
      const myElement = document.querySelector('#app-embed');
      // Access the shadow root
      const shadowRoot = myElement.shadowRoot;
      if (!shadowRoot) {
        return;
      }

      const pElement = shadowRoot.querySelector('._label_1yit2_10');
      const buttonElement = shadowRoot.querySelector('._selectToggle_1yit2_25');
        
      if (pElement) {

          pElement.setAttribute("tabindex","-1");
        
          pElement.style.display = "none";

          const accessibleLabel = document.createElement('label');
          accessibleLabel.style.display = 'block';
          accessibleLabel.className = '_label_1yit2_10';
          accessibleLabel.textContent = pElement.textContent || '';
          pElement.insertAdjacentElement('afterend', accessibleLabel);

          if (buttonElement) {
            buttonElement.setAttribute("aria-label", pElement.textContent || '');
          }
  
        }
      }
       },2000);
}
/* ADA issue PDP page zoom button aria-haspopup fixed by Arpit */
const galleryExpandButton = document.querySelector('.product-gallery--expand');
const pswpElement = document.querySelector('.pswp'); // change selector to the exact element

function updateAriaHasPopup() {
  const isPswpOpen = document.querySelector('.pswp--open') !== null;

  if (galleryExpandButton) {
    galleryExpandButton.setAttribute('aria-haspopup', isPswpOpen ? 'true' : 'false');
  }
}

updateAriaHasPopup();

if (pswpElement) {
  const observer = new MutationObserver(() => {
    updateAriaHasPopup();
  });

  observer.observe(pswpElement, {
    attributes: true,
    attributeFilter: ['class']
  });
}



/* ADA h1 tag issue fixed by Supriya Patil */
$(document).ready(function () {
  // Get current template name from body class
  var template = $('body').attr('class');

  // Check if current template is index, product, or cart
  if (/template-index/.test(template)) {
    var $siteLogo = $('.site-logo');

    
    if (!$siteLogo.closest('h1').length) {
      $siteLogo.wrap('<h1 class="site-logo-heading" aria-label="Macmillan Education"></h1>');
    }
  }
});

//PDP page MEC condition if above 100 quantity then disabled add to cart button
function showErrorMessage() {
      let productForm = document.querySelector('.product-form--atc');
      let existingMessage = document.getElementById('mec-error-message');
      if (!existingMessage) {
        let errorMessage = document.createElement('div'); // Dynamically create the div
        errorMessage.id = 'mec-error-message'; // Set ID
        errorMessage.className = 'mec-error-message'; // Set class
        errorMessage.innerHTML = 'Sorry, we are only serving up to 100 licences for now. If you need more, please contact us: <a href="mailto:help@macmillaneducation.com">Contact Us</a>';
        // Insert the error message right after the closing of the .product-form--atc element
        productForm.insertAdjacentElement('afterend', errorMessage);
   }
}
// Function to remove the error message
function removeErrorMessage() {
      let existingMessage = document.getElementById('mec-error-message');
      if (existingMessage) {
        existingMessage.remove(); // Remove the div if it exists
      }
}

    $('.template-product .quantity-selector__input').on('input change', function () {
        const quantity = parseInt($(this).val());
        const mecFlag = $(this).closest('.product-form--atc').data('mec');
        const $button = $('.product-form--atc-button');
        if(mecFlag){
        if (!isNaN(quantity) && quantity > 100) {
            $button.prop('disabled', true);
            $button.hide();
            showErrorMessage();
            
        } else {
            $button.prop('disabled', false);
            $button.show();
            removeErrorMessage();
        }
        }
});

  $('.template-product .quantity-selector__button--plus').on('click', function () {
        const quantity = parseInt($(".quantity-selector__input").val()) + 1;
        const mecFlag = $(this).closest('.product-form--atc').data('mec');
        const $button = $('.product-form--atc-button');
        if(mecFlag){
        if (!isNaN(quantity) && quantity > 100) {
            $button.prop('disabled', true);
            $button.hide();
            showErrorMessage();
        } else {
            $button.prop('disabled', false);
            $button.show();
            removeErrorMessage();
        }
        }
});

  $('.template-product .quantity-selector__button--minus').on('click', function () {
        const quantity = parseInt($(".quantity-selector__input").val()) - 1;
        const mecFlag = $(this).closest('.product-form--atc').data('mec');
        const $button = $('.product-form--atc-button');
        if(mecFlag){
        if (!isNaN(quantity) && quantity > 100) {
            $button.prop('disabled', true);
             $button.hide();
            showErrorMessage();
        } else {
            $button.prop('disabled', false);
            $button.show();
            removeErrorMessage();
        }
        }
});

//Product magnifier accessibility issue

const items = document.querySelectorAll(".product-gallery--loaded-image");

items.forEach(item => {

  // When user presses Enter on a focused element
  item.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      item.click();   // trigger click
    }
  });
});


// Accessibility magnifier issue fix
(function () {
  'use strict';

  const BUTTON_CLASS = 'pswp-keyboard-zoom-control';
  const FOCUS_CLASS = 'pswp-keyboard-image-focused';
  const INSTRUCTION_CLASS = 'pswp-keyboard-zoom-instruction';
  const STYLE_ID = 'pswp-keyboard-zoom-styles';


  /* =====================================================
     GET PHOTOSWIPE ROOT
  ===================================================== */
  function getPhotoSwipeRoot() {
    return (
      document.querySelector('[data-photoswipe]') ||
      document.querySelector('.pswp')
    );
  }


  /* =====================================================
     GET OPEN PHOTOSWIPE
  ===================================================== */
  function getOpenPhotoSwipe() {
    return document.querySelector('.pswp.pswp--open');
  }


  /* =====================================================
     GET CURRENT VISIBLE IMAGE
  ===================================================== */
  function getCurrentImage(pswp) {

    if (!pswp) return null;

    const items = pswp.querySelectorAll('.pswp__item');

    for (let i = 0; i < items.length; i++) {

      const item = items[i];

      const transform =
        item.style.transform ||
        window.getComputedStyle(item).transform ||
        '';

      /*
       * Current PhotoSwipe slide normally:
       * translate3d(0px, 0px, 0px)
       */
      if (
        transform.indexOf('translate3d(0px') !== -1 ||
        transform.indexOf('translate(0px') !== -1
      ) {

        const image = item.querySelector(
          '.pswp__img:not(.pswp__img--placeholder)'
        );

        if (
          image &&
          window.getComputedStyle(image).display !== 'none'
        ) {
          return image;
        }
      }
    }


    /*
     * Fallback:
     * find visible image inside viewport
     */
    const images = pswp.querySelectorAll(
      '.pswp__img:not(.pswp__img--placeholder)'
    );

    for (let i = 0; i < images.length; i++) {

      const image = images[i];
      const rect = image.getBoundingClientRect();

      if (
        rect.width > 0 &&
        rect.height > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0 &&
        rect.top < window.innerHeight &&
        rect.bottom > 0
      ) {
        return image;
      }
    }

    return null;
  }


  /* =====================================================
     TRIGGER PHOTOSWIPE ZOOM

     Your PhotoSwipe uses custom "pswpTap".
     So we trigger the same event that mouse interaction
     uses instead of using image.click().
  ===================================================== */
  function triggerPhotoSwipeZoom(keyboardEvent) {

    const pswp = getOpenPhotoSwipe();

    if (!pswp) return;

    const image = getCurrentImage(pswp);

    if (!image) return;

    const rect = image.getBoundingClientRect();

    const releasePoint = {
      x: rect.left + (rect.width / 2),
      y: rect.top + (rect.height / 2)
    };


    const tapEvent = new CustomEvent(
      'pswpTap',
      {
        bubbles: true,
        cancelable: true,

        detail: {

          origEvent: keyboardEvent,

          /*
           * PhotoSwipe checks target for:
           * pswp__img
           */
          target: image,

          releasePoint: releasePoint,

          /*
           * Required for desktop zoom path
           */
          pointerType: 'mouse'
        }
      }
    );


    /*
     * Dispatch from actual image.
     * Event bubbles to pswp__scroll-wrap.
     */
    image.dispatchEvent(tapEvent);
  }


  /* =====================================================
     UPDATE ACCESSIBILITY TEXT
  ===================================================== */
  function updateZoomButtonLabel() {

    const pswp = getOpenPhotoSwipe();

    if (!pswp) return;

    const button = pswp.querySelector(
      '.' + BUTTON_CLASS
    );

    if (!button) return;


    const instruction = button.querySelector(
      '.' + INSTRUCTION_CLASS
    );


    /*
     * ZOOMED IN
     */
    if (
      pswp.classList.contains('pswp--zoomed-in')
    ) {

      button.setAttribute(
        'aria-label',
        'Product image zoomed in. Press Enter or Space to zoom out.'
      );

      button.setAttribute(
        'aria-pressed',
        'true'
      );


      if (instruction) {

        instruction.textContent =
          'Press Enter or Space to zoom out';

      }

    }


    /*
     * NORMAL / ZOOMED OUT
     */
    else {

      button.setAttribute(
        'aria-label',
        'Product image. Press Enter or Space to zoom in.'
      );

      button.setAttribute(
        'aria-pressed',
        'false'
      );


      if (instruction) {

        instruction.textContent =
          'Press Enter or Space to zoom image';

      }

    }
  }


  /* =====================================================
     CREATE KEYBOARD ZOOM BUTTON

     IMPORTANT:
     We create this before PhotoSwipe opens so your
     existing trapFocus() sees this as a focusable button.
  ===================================================== */
  function createZoomButton() {

    const pswp = getPhotoSwipeRoot();

    if (!pswp) return;


    /*
     * Prevent duplicate button
     */
    if (
      pswp.querySelector('.' + BUTTON_CLASS)
    ) {
      return;
    }


    const scrollWrap = pswp.querySelector(
      '.pswp__scroll-wrap'
    );

    if (!scrollWrap) return;


    /*
     * CREATE BUTTON
     */
    const button = document.createElement('button');

    button.type = 'button';

    button.className = BUTTON_CLASS;


    button.setAttribute(
      'aria-label',
      'Product image. Press Enter or Space to zoom in.'
    );


    button.setAttribute(
      'aria-pressed',
      'false'
    );


    /*
     * CREATE VISIBLE ACCESSIBILITY INSTRUCTION
     */
    const instruction = document.createElement('span');

    instruction.className = INSTRUCTION_CLASS;

    instruction.textContent =
      'Press Enter or Space to zoom image';


    button.appendChild(instruction);


    /*
     * Insert button before PhotoSwipe content.
     *
     * This is important because the theme's
     * focus trap calculates focusable elements
     * when the popup opens.
     */
    scrollWrap.insertBefore(
      button,
      scrollWrap.firstChild
    );


    /* =================================================
       FOCUS
    ================================================= */
    button.addEventListener(
      'focus',
      function () {

        const openPswp = getOpenPhotoSwipe();

        if (!openPswp) return;


        /*
         * Add class so we can draw focus
         * around actual image.
         */
        openPswp.classList.add(
          FOCUS_CLASS
        );


        updateZoomButtonLabel();
      }
    );


    /* =================================================
       BLUR
    ================================================= */
    button.addEventListener(
      'blur',
      function () {

        const openPswp = getOpenPhotoSwipe();

        if (!openPswp) return;


        openPswp.classList.remove(
          FOCUS_CLASS
        );
      }
    );


    /* =================================================
       CLICK

       Native button activation supports:
       Enter
       Space
    ================================================= */
    button.addEventListener(
      'click',
      function (event) {

        /*
         * Ignore keyboard-generated click because
         * keydown handler below already handles it.
         *
         * event.detail === 0 generally indicates
         * keyboard-generated activation.
         */
        if (event.detail === 0) {
          return;
        }


        event.preventDefault();
        event.stopPropagation();


        triggerPhotoSwipeZoom(event);


        /*
         * PhotoSwipe zoom animation = about 333ms.
         */
        window.setTimeout(
          function () {

            updateZoomButtonLabel();

            button.focus({
              preventScroll: true
            });

          },
          400
        );

      }
    );
  }


  /* =====================================================
     KEYBOARD ENTER / SPACE

     Capture phase is used so PhotoSwipe/theme keyboard
     handlers cannot consume the event before us.
  ===================================================== */
  document.addEventListener(
    'keydown',
    function (event) {

      const target = event.target;


      /*
       * Only run when our keyboard zoom control
       * currently has focus.
       */
      if (
        !target ||
        !target.classList ||
        !target.classList.contains(
          BUTTON_CLASS
        )
      ) {
        return;
      }


      /*
       * Only ENTER or SPACE
       */
      if (
        event.key !== 'Enter' &&
        event.key !== ' ' &&
        event.code !== 'Space'
      ) {
        return;
      }


      event.preventDefault();

      /*
       * Prevent PhotoSwipe/theme from processing
       * this keyboard event separately.
       */
      event.stopImmediatePropagation();


      /*
       * Trigger existing PhotoSwipe zoom.
       */
      triggerPhotoSwipeZoom(event);


      /*
       * Wait for zoom animation.
       */
      window.setTimeout(
        function () {

          updateZoomButtonLabel();


          /*
           * Keep focus on image zoom control.
           */
          target.focus({
            preventScroll: true
          });

        },
        400
      );

    },

    /*
     * Capture phase
     */
    true
  );


  /* =====================================================
     SETUP OPEN PHOTOSWIPE
  ===================================================== */
  function setupOpenPhotoSwipe() {

    const pswp = getOpenPhotoSwipe();

    if (!pswp) return;


    /*
     * IMPORTANT ACCESSIBILITY FIX
     *
     * Do not leave active interactive content
     * inside aria-hidden="true".
     */
    const container = pswp.querySelector(
      '.pswp__container'
    );


    if (
      container &&
      container.getAttribute('aria-hidden') === 'true'
    ) {

      container.removeAttribute(
        'aria-hidden'
      );

    }


    updateZoomButtonLabel();
  }


  /* =====================================================
     ADD CSS USING JAVASCRIPT
  ===================================================== */
  function addStyles() {

    /*
     * Prevent duplicate CSS
     */
    if (
      document.getElementById(STYLE_ID)
    ) {
      return;
    }


    const style = document.createElement(
      'style'
    );


    style.id = STYLE_ID;


    style.textContent = `

      /*
       * ==========================================
       * KEYBOARD ZOOM CONTROL
       * ==========================================
       */

      .${BUTTON_CLASS} {

        position: absolute !important;

        top: 0 !important;
        left: 0 !important;

        width: 100% !important;
        height: 100% !important;

        z-index: 2 !important;

        padding: 0 !important;
        margin: 0 !important;

        border: 0 !important;

        background: transparent !important;

        /*
         * Keep existing mouse interaction
         * working directly on PhotoSwipe image.
         */
        pointer-events: none !important;

      }


      /*
       * Don't draw focus around the
       * full-screen transparent button.
       */
      .${BUTTON_CLASS}:focus,
      .${BUTTON_CLASS}:focus-visible {

        outline: none !important;

      }


      /*
       * ==========================================
       * DRAW FOCUS AROUND ACTUAL PRODUCT IMAGE
       * ==========================================
       */

      .${FOCUS_CLASS}
      .pswp__item
      .pswp__img:not(.pswp__img--placeholder) {

        outline:
          4px solid #ffffff !important;

        outline-offset:
          -8px !important;

        box-shadow:
          0 0 0 2px #000000 !important;

      }


      /*
       * ==========================================
       * ACCESSIBILITY INSTRUCTION
       * ==========================================
       */

      .${INSTRUCTION_CLASS} {

        position: absolute !important;

        left: 50% !important;

        bottom: 30px !important;

        transform:
          translateX(-50%) !important;


        /*
         * Visual styling
         */
        background:
          #000000 !important;

        color:
          #ffffff !important;


        padding:
          10px 16px !important;

        border-radius:
          4px !important;


        font-size:
          14px !important;

        font-weight:
          600 !important;

        line-height:
          1.4 !important;


        white-space:
          nowrap !important;


        /*
         * Hidden until keyboard focus
         */
        opacity:
          0;

        visibility:
          hidden;


        pointer-events:
          none !important;


        z-index:
          9999 !important;

      }


      /*
       * ==========================================
       * SHOW INSTRUCTION WHEN KEYBOARD FOCUSED
       * ==========================================
       */

      .${BUTTON_CLASS}:focus
      .${INSTRUCTION_CLASS},

      .${BUTTON_CLASS}:focus-visible
      .${INSTRUCTION_CLASS} {

        opacity:
          1 !important;

        visibility:
          visible !important;

      }


      /*
       * ==========================================
       * MOBILE
       * ==========================================
       */

      @media (max-width: 767px) {

        .${INSTRUCTION_CLASS} {

          bottom:
            20px !important;

          font-size:
            13px !important;

          padding:
            8px 12px !important;

          white-space:
            normal !important;

          width:
            max-content !important;

          max-width:
            80% !important;

          text-align:
            center !important;

        }

      }

    `;


    document.head.appendChild(
      style
    );
  }


  /* =====================================================
     MUTATION OBSERVER

     PhotoSwipe dynamically changes:
     pswp--open
     pswp--visible
     pswp--zoomed-in
     aria-hidden
  ===================================================== */

  let scheduled = false;


  const observer = new MutationObserver(
    function () {

      if (scheduled) {
        return;
      }


      scheduled = true;


      window.requestAnimationFrame(
        function () {

          scheduled = false;


          /*
           * Re-create control if PhotoSwipe
           * markup gets rebuilt.
           */
          createZoomButton();


          /*
           * Update current popup.
           */
          setupOpenPhotoSwipe();

        }
      );

    }
  );


  /* =====================================================
     INITIALIZATION
  ===================================================== */
  function init() {

    /*
     * Add CSS
     */
    addStyles();


    /*
     * IMPORTANT:
     * Create button before gallery opens.
     */
    createZoomButton();


    /*
     * Watch PhotoSwipe changes.
     */
    observer.observe(
      document.documentElement,
      {

        childList: true,

        subtree: true,

        attributes: true,

        attributeFilter: [
          'class',
          'aria-hidden'
        ]

      }
    );


    setupOpenPhotoSwipe();
  }


  /* =====================================================
     START
  ===================================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();



